module.exports = __webpack_public_path__ + "img/chevron-double-right.2d0aac9d.svg";